import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "p-3 pb-0 card-header" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = { class: "p-3 card-body" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "ni ni-mobile-button text-white opacity-10" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "d-flex flex-column" }
const _hoisted_9 = { class: "mb-1 text-sm text-dark" }
const _hoisted_10 = { class: "text-xs" }
const _hoisted_11 = { class: "font-weight-bold" }
const _hoisted_12 = { class: "d-flex" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", {
  class: "ni ni-bold-right",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "ni ni-mobile-button text-white opacity-10" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-1 text-sm text-dark" }, "Nenhum Incidente reportado")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.cardTitle), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("ul", {
        class: _normalizeClass(["list-group", this.$store.state.isRTL ? 'pe-0' : ''])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.incidentes, (m) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass(["mb-2 border-0 list-group-item d-flex justify-content-between border-radius-lg", this.$store.state.isRTL ? 'pe-0' : 'ps-0'])
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: _normalizeClass(["text-center shadow icon icon-shape icon-sm bg-gradient-dark", this.$store.state.isRTL ? 'ms-3' : 'me-3'])
              }, _hoisted_7, 2),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h6", _hoisted_9, _toDisplayString(m.descricao), 1),
                _createElementVNode("span", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_ctx.fDate( m.data_inicio )) + ", ", 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(m.pedido.numero_pedido), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.gotoPedido( m )),
                class: "my-auto btn btn-link btn-icon-only btn-rounded btn-sm text-dark icon-move-right"
              }, _hoisted_15, 8, _hoisted_13)
            ])
          ], 2))
        }), 256)),
        (_ctx.incidentes.length==0)
          ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", {
                  class: _normalizeClass(["text-center shadow icon icon-shape icon-sm bg-success", this.$store.state.isRTL ? 'ms-3' : 'me-3'])
                }, _hoisted_19, 2),
                _hoisted_20
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}